import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicStudentWhoBig({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 8.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM12 16a4 4 0 100-8 4 4 0 000 8zM4.94 8.89l2.15 2.15a5.03 5.03 0 00.33 2.98H2.8a1.3 1.3 0 01-1.29-1.29v-.26A3.6 3.6 0 014.94 8.9zm8.51 2.33a1.05 1.05 0 00-.08-.84c-.1-.16-.2-.3-.35-.41-.14-.11-.3-.2-.47-.27a1.66 1.66 0 00-2.03.76.13.13 0 00-.02.1c0 .03.02.05.05.08l.54.4c.02.02.05.03.08.03.04 0 .07-.02.1-.06.15-.19.27-.31.34-.37.1-.06.21-.1.36-.1a.6.6 0 01.34.11c.1.07.15.15.15.24 0 .1-.02.19-.08.25a.8.8 0 01-.27.18c-.17.08-.32.2-.46.35a.75.75 0 00-.21.51v.28c0 .04 0 .08.03.12.02.04.05.06.08.06h.78c.04 0 .07-.02.1-.05a.17.17 0 00.03-.1.9.9 0 01.09-.36.53.53 0 01.22-.2 5.85 5.85 0 00.39-.26.92.92 0 00.18-.2.84.84 0 00.11-.25zM12 14.4a.67.67 0 100-1.35.67.67 0 000 1.35z"
      />
    </svg>
  );
}

SvgBasicStudentWhoBig.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicStudentWhoBig.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicStudentWhoBig svgRef={ref} {...props} />
));
export default ForwardRef;
